import React, { useEffect,useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import "./style.css";
import M from "materialize-css";
import { getTranslationPrice } from "./../../actions/translationActions.js";


export default function TranslationFee(props) {

  const [fromLanguageID,setFromLanguageID]=useState(null);
  const [toLanguageID,setToLanguageID]=useState(null);
  const [language,setLanguage]=useState(1);
  const dispatch = useDispatch();
  const translation = useSelector((state) => state.translation.translation);

  useEffect(() => {
    var elems = document.querySelectorAll("select");
    M.FormSelect.init(elems, {});

    if (fromLanguageID!=null && toLanguageID!=null && fromLanguageID!=toLanguageID)
    {
        dispatch(getTranslationPrice({
            from:fromLanguageID,
            to:toLanguageID
        }));
    }

  },[fromLanguageID,toLanguageID]);


  function TextBoxValue(props)
  {
        let value="";
        if (props.data)
        {
            if (language==1) value=props.data.yang+' ¥';
            else if (language==2) value=props.data.dollar+' $';
        }

        return <input type="text" readOnly={true}  value={value} />
    }

 

  return (
    <div className="card card-content translation_service_container">
      <div className="row">
        <div className="col m6">
          <select onChange={(e)=>setFromLanguageID(e.target.value)}>
            <option value="" disabled selected>
              Choose a language
            </option>
            {props.language.map((val) => {
              return <option value={val.id}>{val.name}</option>;
            })}
          </select>
        </div>
        <div className="col m6">
          <select onChange={(e)=>setToLanguageID(e.target.value)}>
            <option value="" disabled selected>
              Choose a language
            </option>
            {props.language.map((val) => {
              return <option value={val.id}>{val.name}</option>;
            })}
          </select>
        </div>
        <div className="col m1">
          <br />
          <span>Price</span>
        </div>
        <div className="col m5">
            <TextBoxValue data={translation} />
        </div>
        <div className="col m5 center">
          <br />
          <button className="btn" onClick={()=>setLanguage(1)}> ¥</button>
          <button className="btn" onClick={()=>setLanguage(2)} style={{ marginLeft: 20 }}>
            $
          </button>
        </div>
      </div>
    </div>
  );
}
